/**
 * 任务指派
 * 2019-05-08
 * Qian.qianchen
 */
"use strict";
angular.module("assignmentsModule", [
    "assignmentsRouterModule", //任务指派线索总路由
    "allAssignmentsModule", //所有任务模块
    "pendingAssignmentsModule", //待审任务模块
]);